import { Component, OnInit, ElementRef, Inject } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { CurrencyDialogComponent } from '../../dialog/currencies/currency-dialog.component';
import { ProjectsService } from '../../services/projects-proposals-service/projects-proposals.service';

import { IInvoice } from '../../manage-invoice/manage-invoice.interfaces';
import * as moment from 'moment';

@Component({
  selector: 'dialog-factures',
  templateUrl: 'dialog.component.factures.html',
  styleUrls: ['dialog.component.factures.css'],
  providers: [ProjectsService]
})

export class DialogFactures {
  public tx_avis_data_cobrament: boolean = false;
  //public possibleMonedes: Array<string>;
  public possibleMonedes: { codi: string; text: string; }[];

  public possibleFites: Array<string>;
  
  public invoiceTable: string = 'invoice';
  public invoice: IInvoice = {'id': 0, 'projecte_codi': '', 'fita': '', 'objecte_lliurament': '',
    'facturacio_prevista_percent': 0, 'facturacio_prevista_eur': 0, 'numero_factura': 0, 'observacions': '',
    'data_factura': '', 'data_cobrament': '', 'data_factura_prevista': '', 'data_cobrament_prevista': '',
    'impostos':0, 'previsio_cobrament': 0, 'facturacio_cobrament': 0, 'facturacio_prevista_loc': 0,
    'moneda_previsio': '', 'canvi_moneda': 0, 'iva': 0, 'pressupost': null, 'activa': true, 'clau': '',
    'facturar': false
  };
  public editInvoiceData = Object.assign(
    this.invoice,
    {},
      {}
  );
  public cobrament_modificat: boolean = false;

  public openCurrencyDialog(): void {
    this.dialog.open(CurrencyDialogComponent, {
      panelClass: 'currency-dialog-panel',
      autoFocus: false
    });
  }

  public enviaMsg(){
    this.dataService.sendMessage(this.editInvoiceData.projecte_codi, "S'ha actualitzat la data de cobrament")
    .subscribe(resul => console.log("OK"), err => console.log(err));
  }

  constructor(public translate: TranslateService, public languageService: LanguageService, protected dataService: ProjectsService, private dialog: MatDialog, public dialogRef: MatDialogRef<DialogFactures>, @Inject(MAT_DIALOG_DATA) public data: any){
   this.editInvoiceData = data.fact;
   this.invoiceTable = data.taula;
   //this.dataService.getMonedes().subscribe(monedes => this.possibleMonedes = monedes, err => console.log(err));
   this.dataService.getMonedes().subscribe(monedes => {
      this.possibleMonedes = monedes.map(nomCatala => ({
        codi: nomCatala["value"], // ← s'envia/compara SEMPRE en català
        text: this.languageService.label('monedesRaw', nomCatala["value"]) // ← només es mostra traduït
      }));
    });

   this.dataService.getFites(this.editInvoiceData.projecte_codi).subscribe(fites => this.possibleFites = fites, err => console.log(err));
   //if(this.editInvoiceData.previsio_cobrament == 0 || !this.editInvoiceData.previsio_cobrament)
   //   this.editInvoiceData.previsio_cobrament = this.editInvoiceData.facturacio_prevista_eur;
   if(!this.editInvoiceData.canvi_moneda)this.editInvoiceData.canvi_moneda = 1;
   if(!this.editInvoiceData.moneda_previsio)this.editInvoiceData.moneda_previsio = 'Euro';
   //if(!this.editInvoiceData.facturacio_prevista_percent)
    this.editInvoiceData.facturacio_prevista_percent = (this.editInvoiceData.pressupost?Number((this.editInvoiceData.facturacio_prevista_loc/this.editInvoiceData.pressupost*100).toFixed(1)):null);
  }
  
  avis_data_cobrament(): void {
   if(this.editInvoiceData.data_cobrament)this.tx_avis_data_cobrament = true;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  desar(): void {

    if(this.data.data_factura_prevista && !moment(this.data.data_factura_prevista.value, 'YYYY-MM-DD', true).isValid()) {alert("data_factura_prevista. Format ERROR");return;}
    if(this.data.data_factura && !moment(this.data.data_factura.value, 'YYYY-MM-DD', true).isValid()) {alert("data_factura. Format ERROR");return;}
    if(this.data.data_cobrament_prevista && !moment(this.data.data_cobrament_prevista.value, 'YYYY-MM-DD', true).isValid()) {alert("data_cobrament_prevista. Format ERROR");return;}
    if(this.data.data_cobrament && !moment(this.data.data_cobrament.value, 'YYYY-MM-DD', true).isValid()) {alert("data_cobrament. Format ERROR");return;}

    if(this.cobrament_modificat)this.enviaMsg();
    if(!(this.editInvoiceData.data_factura_prevista == null || this.editInvoiceData.data_factura_prevista == '') && isNaN(Date.parse(this.editInvoiceData.data_factura_prevista))){alert("Data factura prevista. Invalida");return;}
    if(!(this.editInvoiceData.data_cobrament_prevista == null || this.editInvoiceData.data_cobrament_prevista == '') && isNaN(Date.parse(this.editInvoiceData.data_cobrament_prevista))){alert("Data cobrament prevista. Invalida");return;}
    if(!(this.editInvoiceData.data_factura == null || this.editInvoiceData.data_factura == '') && isNaN(Date.parse(this.editInvoiceData.data_factura))){alert("Data factura. Invalida");return;}
    if(!(this.editInvoiceData.data_cobrament == null || this.editInvoiceData.data_cobrament == '') && isNaN(Date.parse(this.editInvoiceData.data_cobrament))){alert("Data cobrament. Invalida");return;}
    this.editInvoiceData.facturacio_prevista_percent = (this.editInvoiceData.pressupost?Number((this.editInvoiceData.facturacio_prevista_loc/this.editInvoiceData.pressupost*100).toFixed(1)):null);
    this.dialogRef.close(this.editInvoiceData);
  }

  close(): void {
    this.dialogRef.close(null);
  }

  ngOnInit(){
  }

  chgImportFactura(){
    this.editInvoiceData.facturacio_prevista_percent = (this.editInvoiceData.pressupost?Number((this.editInvoiceData.facturacio_prevista_loc/this.editInvoiceData.pressupost*100).toFixed(1)):null);
  }
}